import React from 'react'
import { api } from '@api/index'
import useModal, { ModalOnCencel, ModalOnConfrim } from '@hooks/useModal'
import { Message } from '@utils/message'
import objToFormdata from '@utils/objToFormdata'
import { FieldValues, useForm } from 'react-hook-form'
import { useMutation } from 'react-query'
import MessageModal from '../../shared/MessageModal'
import 'twin.macro'

interface Props {
  event: EventInfo
  onConfirm?: ModalOnConfrim
  onCencel?: ModalOnCencel
}

const EditEventModal = ({ event, onConfirm, onCencel }: Props) => {
  const [openResModal] = useModal()
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onChange' })

  setValue('title', event.title)
  setValue('url', event.url)

  const addVideoMutation = useMutation(
    (formData: FormData) =>
      api.adminService.mdoifyEvent({
        ...event,
        title: formData.get('title') as string,
        url: formData.get('url') as string,
      }),
    {
      onError: async () => {
        const res = await openResModal(
          <MessageModal>{Message.error.FAIL_ADD_VIDEO}</MessageModal>
        )
        if (res) {
          onConfirm?.(false, 200)
        }
      },
      onSuccess: async () => {
        const res = await openResModal(
          <MessageModal>{Message.info.SUCCESS_ADD_VIDEO}</MessageModal>
        )
        if (res) {
          onConfirm?.(true, 200)
        }
      },
    }
  )

  const handelSubmitAddVideo = (form: FieldValues) => {
    const formData = objToFormdata(form)
    addVideoMutation.mutate(formData)
  }

  return (
    <div className="px-20 py-20 max-w-500 modal">
      <form onSubmit={handleSubmit(handelSubmitAddVideo)}>
        <div className="justify-start mb-20 text-xl font-bold">이벤트 수정</div>
        <div className="flex flex-col w-full gap-12 mb-3">
          <label className="text-base font-bold text-gray-500">제목</label>
          <input
            {...register('title', { required: Message.valid.REQUIRE_TITLE })}
            type="text"
            className="input"
            placeholder="동영상 제목을 입력해 주세요."
            tw="h-40"
          />
          <div className="flex items-center py-1 text-base text-red-500 h-11">
            {errors?.title?.message}
          </div>
          <label className="text-base font-bold text-gray-500">URL 주소</label>
          <input
            {...register('url', {
              required: Message.valid.REQUIRE_URL,
              pattern: {
                value:
                  /(?:(?:https?:\/\/)(?:www)?\.?(?:youtu\.?be)(?:\.com)?\/(?:.*[=/])*)([^= &?/\r\n]{8,11})/,
                message: Message.valid.INVALID_URL,
              },
            })}
            tw="h-40"
            type="text"
            className="input"
            value={event.title}
            placeholder="URL 주소를 입력해 주세요."
          />
          <div className="flex items-center py-2 text-base text-red-500 h-11 ">
            {errors?.url?.message}
          </div>
        </div>
        <div className="flex justify-end w-full gap-8 mt-10 text-base font-bold">
          <button
            type="button"
            onClick={onConfirm}
            className="px-20 py-6 button"
          >
            취소
          </button>
          <button
            type="submit"
            onClick={onCencel}
            className="px-20 py-6 button"
          >
            수정
          </button>
        </div>
      </form>
    </div>
  )
}

export default EditEventModal
